<app-search></app-search>
<!--<div class="container-fluid">-->
<div class="row" style="margin-right: unset;">
  <div class="col-md-12" style="padding-right:0">
    <app-map-with-input recordType="sites" [id]="id" [showStatusInput]="true"
                        [fields]="[{'key': 'name', 'columns': 7},
                               {'key': 'site_id'},
                               {'key': 'parcel_id'},
                                {'key': 'streetaddress'},
                                {'key': 'supplemental_location'},
                                {'key': 'village'},
                                {'key': 'classification'},
                                {'key': 'horizontal_collection_method'}]">
    </app-map-with-input>
    <!-- /.container-fluid -->
  </div>
  <!-- /#page-wrapper -->

</div>

<div class="panel panel-default" style="border: none;" *ngIf="id !== 'new'">
  <app-expand-collapse>
    <app-add-program-button [site_id]="id"></app-add-program-button>
  </app-expand-collapse>

  <!--    &lt;!&ndash; related sites &ndash;&gt;-->
  <!--    <div class="row" style="margin:10px 0px">-->
  <!--      <div class="col-md-12">-->
  <!--        <div ng-controller="RelatedSitesCtrl" ng-cloak class="panel panel-default">-->
  <!--          <div class="panel-heading" ng-init="relatedIsCollapsed = true"-->
  <!--               ng-click="relatedIsCollapsed = !relatedIsCollapsed">-->
  <!--            <h4 class="panel-title">-->
  <!--              <a role="button">-->
  <!--                <span ng-show="loading"><i class="fa fa-spinner fa-pulse"></i></span>-->
  <!--                <i ng-show="relatedIsCollapsed && relatedSites.length > 0"-->
  <!--                   class="pull-left fa fa-chevron-down"></i>-->
  <!--                <i ng-show="!relatedIsCollapsed && relatedSites.length > 0"-->
  <!--                   class="pull-left fa fa-chevron-up"></i>-->
  <!--                <span ng-if="relatedSites.length === 0">No </span>-->
  <!--                Related Sites-->
  <!--              </a>-->
  <!--              <div class="pull-right" ng-if="relatedSites.meta.permissions.write">-->
  <!--                                        <span ng-hide="loading" style="cursor: pointer;" ng-click="open({}, $event)">-->
  <!--                                            Add Related Site-->
  <!--                                            <i class="fa fa-plus-circle"></i>-->
  <!--                                        </span>-->
  <!--              </div>-->
  <!--            </h4>-->
  <!--          </div>-->
  <!--          <div class="panel-body" uib-collapse="relatedIsCollapsed" ng-show="relatedSites.length > 0">-->
  <!--            <table st-table="displayedRelatedSites" st-safe-src="relatedSites"-->
  <!--                   class="table table-striped">-->
  <!--              <thead>-->
  <!--              <tr>-->
  <!--                <th>Name</th>-->
  <!--                <th style="width:25px" ng-if="relatedSites.meta.permissions.write">Delete</th>-->

  <!--              </tr>-->
  <!--              </thead>-->
  <!--              <tbody>-->
  <!--              <tr ng-show="loading">-->
  <!--                <td colspan="99"><i class="fa fa-spinner fa-pulse"></i></td>-->
  <!--              </tr>-->
  <!--              <tr ng-repeat="relatedSite in relatedSites">-->
  <!--                <td><a ui-sref="root.site.view({id: relatedSite.globalid})">{{ relatedSite.name }}</a>-->
  <!--                </td>-->
  <!--                <td ng-if="relatedSites.meta.permissions.write" ng-click="delete(relatedSite)"><i-->
  <!--                  class="fa fa-times-circle-o fa-lg"-->
  <!--                  style="padding:0px 30%;"></i></td>-->

  <!--              </tr>-->
  <!--              </tbody>-->
  <!--            </table>-->
  <!--          </div>-->

  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    &lt;!&ndash; end related sites &ndash;&gt;-->
  <!--    &lt;!&ndash; environmental interests &ndash;&gt;-->
  <div>
    <app-interest-inline [service]="Beaches" foreignKeyField="site" [id]="id" #beachInline
                         deleteText="Are you sure you want to remove these Beach attributes?">

      <div name="additionalInlines">
        <app-reverse-inline *ngIf="(beachInline.loading | async) && Beaches.item.globalid" [foreignKey]="Beaches.item.globalid"
                            foreignKeyField="monitoringlocation" type="beaches/beach"
                            [displayFields]="['name', 'identifier', 'description', 'comment', 'state_code', 'fips_code',
                'access_type', 'access_comment', 'waterbody_name_code', 'waterbody_type_code', 'extent_length_measure',
                'extent_unit_of_measure', 'effective_year', 'swim_season_startdate', 'swim_season_enddate', 'swim_season_frequency_measure',
                'monitoring_freq_unit_of_measure', 'monitored_irregularly', 'monitored_irregularly_comment', 'tier_ranking',
                'beach_act_indicator', 'pollution_status', 'dormant_indicator', 'website', 'reporting_frequency_measure',
                'reporting_freq_unit_of_measure']"
                            [autocomplete]="{'field': 'name',
                                    'url': '/api/beaches/beach/?search=',
                                    'foreign_key': 'monitoringlocation'}"
                            [featureService]="Beaches.meta.featureService"
                            parentType="beaches/monitoringlocation" parentFkField="beach"
                            deleteText="Are you sure you want to remove this beach from this monitoring location?"
                            [subItems]="[{'name': 'beach_advisory', 'type': 'beaches/beachadvisoryaggregate',
                                    'display_fields': ['type_code', 'name', 'actual_startdate', 'actual_stopdate', 'activity_description',
                                    'activity_comment', 'extent_start_measure', 'extent_length_measure', 'extent_unit_of_measure',
                                    'activity_reason', 'activity_reason_description', 'activity_source', 'activity_source_description',
                                     'activity_indicator', 'activity_indicator_description']},
                                    {'name': 'pollution', 'type': 'beaches/pollution', 'display_fields': ['source_code',
                                    'source_description'], 'foreign_key_field': 'beach',
                                    'deleteText': 'Are you sure you want to remove this pollution type from this beach?' },
                                    {'name': 'procedure', 'type': 'beaches/procedure', 'display_fields': ['type_code',
                                    'description'], 'foreign_key_field': 'beach',
                                    'deleteText': 'Are you sure you want to remove this procedure from this beach?'}]">
          <!--sub-items="[{'name': 'person', 'type': 'beaches/person', 'autocomplete': {'field': 'first_name',
          'url': '/api/beaches/person/?search=', 'foreign_key': 'beach'}, 'display_fields': ['identifier',
          'title', 'first_name', 'middle_initial', 'last_name', 'suffix', 'status', 'is_state_contact',
          'telephone_typecode', 'telephone_number', 'telephone_effective_date', 'telephone_status',
          'electronic_addr_type_code', 'electronic_addr', 'electronic_addr_effdate', 'eletronic_addr_status'],
          'foreign_key_field': 'beach'}]"-->

        </app-reverse-inline>
      </div>
    </app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="PreCERCLIS" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Pre-CERCLIS attributes?"></app-interest-inline>
  </div>
  <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
  <!--    &lt;!&ndash;        <div ng-controller="SolidWasteCtrl" ng-cloak>&ndash;&gt;-->
  <div>
    <app-interest-inline [service]="SolidWaste" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Solid Waste attributes?"></app-interest-inline>
  </div>
  <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
  <div>
    <app-interest-inline [service]="TierII" foreignKeyField="site" [id]="id"
                         deleteText="Are you sure you want to remove these Tier II attributes?"></app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="FUDS" foreignKeyField="site" [id]="id"
                         deleteText="Are you sure you want to remove these FUDS attributes?"></app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="Brownfields" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Brownfields attributes?"></app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="UST" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these UST attributes?"></app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="StandbyGenerators" [id]="id" foreignKeyField="site" #standbyInline
                         deleteText="Are you sure you want to remove these Standby Generator attributes?">
      <div name="addInfo">
        <app-emissions-chart *ngIf="standbyInline.loading | async"
                             [item]="StandbyGenerators.item"></app-emissions-chart>
      </div>
    </app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="OneStop" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Water attributes?">
    </app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="Pesticides" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Pesticide attributes?">
    </app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="ER" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Emergency Response attributes?">
    </app-interest-inline>
  </div>
  <div>
    <app-interest-inline [service]="Complaints" [id]="id" foreignKeyField="site"
                         deleteText="Are you sure you want to remove these Complaint attributes?">
    </app-interest-inline>
  </div>
  <!-- end environmental interest -->

  <div *ngIf="history | async as h">
    <app-generic-inline [items]="h" [disableAdd]="true" [meta]="historyMeta"
                        [disableDelete]="true"></app-generic-inline>
  </div>
  <!--    &lt;!&ndash; contacts &ndash;&gt;-->

  <!--    <div ng-controller="ContactsCtrl" ng-cloak style="padding: 0 15px 0 15px;">-->
  <div style="margin: 0 15px;">
    <app-nested-inline [meta]="Contacts.meta" [foreignKey]="id"></app-nested-inline>
  </div>

  <div style="margin: 0 15px;">
    <app-nested-inline [meta]="Parcels.meta" [foreignKey]="id"></app-nested-inline>
  </div>

  <!--  <app-parcel-inline [foreignKey]="id" [location]="mapService.currentLocation | async"></app-parcel-inline>-->

  <!--    &lt;!&ndash; related attachments &ndash;&gt;-->
  <!--    <attachment-inline style="margin:10px 0px;" type="'siteattachments'" foreign-key="id"></attachment-inline>-->
  <!--    &lt;!&ndash; end related attachments &ndash;&gt;-->

  <!--    &lt;!&ndash; programs &ndash;&gt;-->
  <!--    <div class="row" style="margin:10px 0px;">-->
  <!--      <div class="col-md-12">-->
  <!--        <div ng-controller="ProgramsCtrl" ng-cloak class="panel panel-default">-->
  <!--          <div class="panel-heading" ng-click="programIsCollapsed = !programIsCollapsed">-->
  <!--            <h4 class="panel-title">-->
  <!--              <a role="button">-->
  <!--                <span ng-show="loading"><i class="fa fa-spinner fa-pulse"></i></span>-->
  <!--                <i ng-show="!programIsCollapsed && programs.length > 0"-->
  <!--                   class="pull-left fa fa-chevron-down"></i>-->
  <!--                <i ng-show="programIsCollapsed && programs.length > 0"-->
  <!--                   class="pull-left fa fa-chevron-up"></i>-->
  <!--                <span ng-show="programs.length === 0">No </span>USEPA Programs-->
  <!--                <span ng-show="programs.length === 0">Currently Known</span>-->
  <!--              </a>-->
  <!--            </h4>-->
  <!--          </div>-->
  <!--          <div class="panel-body" ng-show="programs.length > 0 && !loading"-->
  <!--               uib-collapse="!programIsCollapsed">-->

  <!--            <table class="table table-striped">-->
  <!--              <thead>-->
  <!--              <tr>-->
  <!--                <th>Program</th>-->
  <!--                <th>Program ID</th>-->
  <!--              </tr>-->
  <!--              </thead>-->
  <!--              <tbody>-->
  <!--              <tr ng-show="loading">-->
  <!--                <td colspan="99"><i class="fa fa-spinner fa-pulse"></i></td>-->
  <!--              </tr>-->
  <!--              <tr ng-repeat="program in programs">-->
  <!--                <td><a style="cursor:pointer;"-->
  <!--                       ng-click="openLink(program.pgm_sys_acrnm, program.pgm_sys_id)">-->
  <!--                  {{ program.pgm_sys_acrnm }}</a></td>-->
  <!--                <td>{{ program.pgm_sys_id }}</td>-->
  <!--              </tr>-->
  <!--              </tbody>-->
  <!--            </table>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    &lt;!&ndash; endprograms &ndash;&gt;-->
  <!--  </div>-->
</div>
